<template>
    <div>
        <div @click="() => { $GlobalStore.closeLastModal() }">뒤로가기</div>
        <template v-if="step === 0">
            <div>이름 : {{name}}</div>
            <div>연락처 정보 : {{phone}}</div>
            <div>결제 요청 금액 : {{amt | comma}}</div>

            <button @click="processBeforePayDirectly" style="margin-top:20px;padding:10px;">내가 직접 결제하기</button>
            <button @click="requestPay" style="margin-top:20px;padding:10px;">결제 요청하기</button>
        </template>
        <template v-else-if="step === 1">
            결제를 기다리는중
        </template>

    </div>
</template>

<script>
    export default {
        name: "ParentPayWait",
        props : {
            name : {
                type : String,
                default : '',
            },
            phone : {
                type : String,
                default : '',
            },
            amt : {
                type : Number,
                default : 0
            },
            payDirectly : {
                type : Function,
                default : () => {}
            },
            is_waiting_over : {
                type : Boolean,
                default : false
            },
            payByParent : {
                type : Function,
                default : () => {}
            },
        },
        data(){
            return {
                step : 0
            }
        },
        methods : {
            processBeforePayDirectly(){
                this.$GlobalStore.closeLastModal();
                this.payDirectly();
            },
            async requestPay(){
                this.step = 1;
                this.payByParent();
            }
        }
    }
</script>

<style scoped>

</style>